"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITextToolbarSplitSelect = _interopRequireDefault(require("UIComponents/editor/UITextToolbarSplitSelect"));

var ListMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ListMenu, _Component);

  function ListMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListMenu).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleButtonClick = _this.handleButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ListMenu, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var value = _ref.target.value;
      this.props.onListTypeChange(value);
    }
  }, {
    key: "handleButtonClick",
    value: function handleButtonClick() {
      this.props.onClick();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tooltip = _this$props.tooltip,
          options = _this$props.options,
          dropdownClassName = _this$props.dropdownClassName,
          active = _this$props.active,
          value = _this$props.value;
      return _react.default.createElement(_UITextToolbarSplitSelect.default // SlipSelectProps
      , {
        active: active,
        tooltip: tooltip,
        value: value // DropdownProps
        ,
        onButtonClick: this.handleButtonClick,
        dropdownClassName: dropdownClassName,
        onChange: this.handleChange,
        options: options
      });
    }
  }]);
  return ListMenu;
}(_react.Component);

exports.default = ListMenu;
ListMenu.propTypes = {
  active: _react.PropTypes.bool.isRequired,
  onListTypeChange: _react.PropTypes.func.isRequired,
  onClick: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string.isRequired,
  tooltip: _react.PropTypes.string.isRequired,
  dropdownClassName: _react.PropTypes.string,
  options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    icon: _react.PropTypes.string,
    value: _react.PropTypes.string
  }))
};
module.exports = exports.default;